export default __webpack_public_path__ + "static/media/dashboard.895efaf3.svg";